export default __webpack_public_path__ + "static/social media 12-61c964c2c6fe06cd2b7c8d5a546de8ab.webp";